import React, {
	//useState,
	//useEffect,
	//useMemo,
} from 'react';
import { GenericListSelect } from './genericListSelect';

export const timeZones = [
	'Australia/Brisbane'
	, 'Australia/Sydney'
	, 'Australia/Melbourne'
	, 'Australia/Canberra'
	, 'Australia/Adelaide'
	, 'Australia/Darwin'
	, 'Australia/Hobart'
	, 'Australia/Perth'
]

//Time zones https://techsupport.osisoft.com/Documentation/PI-Web-API/help/topics/timezones/iana.html
export const TimezoneSelect = (props) => {

	return (
		<>
			<GenericListSelect
				id = 'timezone'
				label = 'Time zone'
				dataArray = { timeZones }
				cols = { props.cols }
				controlStyle = { props.controlStyle }
				handleChange = {(evt) => props.handleChange(evt)}
				value = { props.value }
				required = { props.required }
				//pattern = {'^\d+$'}	// integer
				pattern = {'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
				invalidMsg = 'Select a time zone'
				lock = { props.lock }
			/>
		</>
	)

}